<template>
    <paper class="appointmentDetail" >
         <!-- 基础信息 -->
        <basic-information :basicInfo="basicInfo"></basic-information>
        <!-- 预约记录 -->
        <appointment-record :appointmentRecordInfo="appointmentRecordInfo"></appointment-record>
        <!-- 拨号记录 -->
        <dialing-record :dialingRecordInfo="dialingRecordInfo"></dialing-record>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import BasicInformation from './components/BasicInformation';
import AppointmentRecord from './components/AppointmentRecord';
import DialingRecord from './components/DialingRecord';
import { formatAppointmentRecordList, formatDialingRecordList } from '../util.js';
import { getAppointmentRecordApi, getDialingRecordApi } from '../../../../api/appointmentCenter';
import { dictWithUrl } from '@/components/lots/api.js';
export default {
    name: 'appointmentDetail',
    components: { paper, BasicInformation, AppointmentRecord, DialingRecord
    },
    data () {
        return {
            btnLoading: false,
            dictDataL: {}, // 数据字典集合
            basicInfo: {}, // 基础信息
            appointmentRecordInfo: [], // 预约记录
            dialingRecordInfo: [], // 拨号记录
            isSearchFresh: true
        };
    },
    methods: {
        /**
         * @description 查询预约记录
         */
        getAppointmentRecord () {
            return getAppointmentRecordApi({ taskNo: this.basicInfo.taskNo }).then(res => {
                if (res && +res.code === 0) {
                    this.appointmentRecordInfo = formatAppointmentRecordList(res.data || [], this.dictData);
                }
            });
        },
        /**
         * @description 查询拨号记录
         */
        getDialingRecordApi () {
            return getDialingRecordApi({ taskNo: this.basicInfo.taskNo }).then(res => {
                if (res && +res.code === 0) {
                    this.dialingRecordInfo = formatDialingRecordList(res.data || [], this.dictData);
                }
            });
        },
        /**
         * @description 获取数据字典
         * 送装需求: INSTALL_TYPE
         * 预约类型: OTP_ACD_APPOINTMENT_TYPE
         */
        async getDicData () {
            const dict = await dictWithUrl(
                'INSTALL_TYPE,OTP_ACD_APPOINTMENT_TYPE'
            );
            this.dictData = dict.data;
        },
        async load () {
            this.basicInfo = this.$route.query.rowData;
            await this.getDicData();
            this.getAppointmentRecord();
            this.getDialingRecordApi();
        }
    },
    mounted () {
        if (this.isSearchFresh) {
            this.load();
            this.isSearchFresh = false;
        }
    },
    activated () {
        if (this.isSearchFresh) {
            this.load();
        }
    },
    deactivated () {
        this.isSearchFresh = true;
    }
};
</script>

<style lang="less" scoped>
@import './appointmentDetail.less';
</style>
